export const TransactionStatus = {
  Success: 1,
  Cancel: 2,
  Void: 3,
  Pending: 4,
  Fail: 5,
};
